export const projectData = [
    {
        id: 1,
        image: '/images/pj-1.png',
        title: 'Dynamic Portfolio Builder',
        description:
            'A full stack portfolio builder where users can create and manage their personal portfolio dynamically.',
        technologies: ['React Js', 'Node Js', 'Express', 'MongoDB'],
    },
    {
        id: 2,
        image: '/images/pj-2.png',
        title: 'Real Estate Website',
        description:
            'A modern real estate platform focused on property listings, buying, and selling experiences.',
        technologies: ['WordPress', 'Elementor', 'PHP'],
    },
    {
        id: 3,
        image: '/images/pj-3.png',
        title: 'Roofing Services Website',
        description:
            'Business website for roofing replacement and repair services with responsive design.',
        technologies: ['WordPress', 'Gutenberg', 'PHP'],
    },
    {
        id: 4,
        image: '/images/pj-4.png',
        title: 'NY Real Estate & Estate Lawyers',
        description:
            'Professional law firm website for real estate transactions and estate planning services.',
        technologies: ['WordPress', 'Gutenberg', 'PHP'],
    },
    {
        id: 5,
        image: '/images/pj-5.png',
        title: 'Technical Fibers Company Website',
        description:
            'Corporate website for a technical fibers manufacturing company serving multiple industries.',
        technologies: ['WordPress', 'Gutenberg', 'PHP'],
    },
    {
        id: 6,
        image: '/images/pj-6.png',
        title: 'Hair Styling Website',
        description:
            'A stylish salon and grooming website focused on user engagement and modern UI.',
        technologies: ['WordPress', 'Elementor', 'PHP'],
    },
    {
        id: 7,
        image: '/images/pj-7.png',
        title: 'React Dashboard Application',
        description:
            'A responsive React application with reusable components and clean UI architecture.',
        technologies: ['React Js', 'HTML', 'Bootstrap'],
    },
]